import { Box, Stack, Typography } from "@mui/material";
import { ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCase } from "../../context/CaseContext";
import { useTheme } from "../../context/ThemeContext";
import { Tabs } from "../general/Tabs";
import { TonalBadge } from "../general/TonalBadge";
import { byName, clientsFirst, sort } from "./AnalyticsUtility";
import { CaseOutcome } from "./CaseOutcome";
import { GuideHeader } from "../guide/GuideHeader";

export const CaseOutcomes = () => {
  const { theme } = useTheme();
  const { t } = useTranslation(undefined, { keyPrefix: "case" });
  const caseContext = useCase();
  const parties = caseContext.getPartyDescriptors();
  const outcomes = caseContext.getOutcomes();

  const sortedParties: string[] = useMemo(
    () => sort(parties, clientsFirst, byName),
    [parties],
  );
  const tabs: { label: ReactNode; tabComponent: ReactNode }[] =
    sortedParties.map((partyId) => {
      const party = parties[partyId];
      const name = party?.name || partyId;
      const outcome = outcomes.find((o) => o.partyId === partyId);
      return {
        label: (
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <span>{name}</span>
            {party?.isClient && (
              <TonalBadge tone={theme.palette.primary}>
                {t("parties.clientBadge")}
              </TonalBadge>
            )}
          </Stack>
        ),
        tabComponent: outcome ? (
          <CaseOutcome outcome={outcome} partyName={name} />
        ) : (
          <Typography sx={{ color: "text.secondary" }}>
            {t("analytics.risk.noOutcomes", { name })}
          </Typography>
        ),
      };
    });

  return (
    <Stack spacing={1.5}>
      {/* the header, and at its end which results the page shows */}
      <GuideHeader>
        <Box>
          <Typography
            variant="h5"
            component="h1"
            sx={{ fontWeight: 700, letterSpacing: "-.01em" }}
          >
            {t("analytics.outcomes.title")}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", mt: 0.5, maxWidth: "76ch" }}
          >
            {t("analytics.outcomes.intro")}
          </Typography>
        </Box>
      </GuideHeader>
      <Box>
        <Tabs tabs={tabs} />
      </Box>
    </Stack>
  );
};
